import { Button, Form, Typography } from "antd";
import { useContext, useEffect } from "react";
import styled from "styled-components";
import { FluxoResposta } from "../cadastroCotaUsuario.types";
import { OnboardingFrame, OnboardingNavigationContext } from "../utils";

interface Props {
  fluxo: FluxoResposta;
  submitting: boolean;
  onConcluir: (payload: Record<string, unknown>) => Promise<void>;
}

const Beneficios = styled.div`
  display: grid;
  gap: 22px;
  margin: 32px 0;

  .beneficio-titulo {
    display: block;
    font-size: 16px;
    margin-bottom: 4px;
  }

  .beneficio-descricao {
    color: #5f6b73;
    line-height: 1.55;
    margin: 0;
  }
`;

const Acoes = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`;

export function EtapaVenda({ fluxo, submitting, onConcluir }: Props) {
  const [form] = Form.useForm();
  const { onVoltar } = useContext(OnboardingNavigationContext);
  const valoresIniciais = fluxo.dadosPreenchidos?.venda as
    | { desejaVender?: boolean }
    | undefined;

  useEffect(() => {
    form.setFieldsValue({ desejaVender: valoresIniciais?.desejaVender });
  }, [form, valoresIniciais?.desejaVender]);

  return (
    <OnboardingFrame
      fluxo={fluxo}
      title="Sua cota pode valer uma boa oportunidade"
      description={
        <>
          Seja para vender agora ou apenas aproveitar uma boa oportunidade no futuro, você pode deixar sua cota anunciada pelo preço de venda que considera interessante.
          <br />
          <br />
          Se aparecer um interessado, você avalia a proposta e decide se quer vender.
        </>
      }
    >
      <Form
        layout="vertical"
        form={form}
        initialValues={{ desejaVender: valoresIniciais?.desejaVender }}
        onFinish={(values) => onConcluir(values)}
      >
        <Form.Item name="desejaVender" hidden>
          <input type="hidden" />
        </Form.Item>

        <Beneficios>
          <div>
            <Typography.Text strong className="beneficio-titulo">
              💰 Você define o valor
            </Typography.Text>
            <Typography.Paragraph className="beneficio-descricao">
              Escolha quanto gostaria de receber pela sua cota.
            </Typography.Paragraph>
          </div>
          <div>
            <Typography.Text strong className="beneficio-titulo">
              🤝 Você decide se vende
            </Typography.Text>
            <Typography.Paragraph className="beneficio-descricao">
              Receber uma proposta não obriga você a fechar negócio.
            </Typography.Paragraph>
          </div>
          <div>
            <Typography.Text strong className="beneficio-titulo">
              📢 Sua cota ganha visibilidade
            </Typography.Text>
            <Typography.Paragraph className="beneficio-descricao">
              Apresente sua cota a pessoas interessadas em multipropriedade.
            </Typography.Paragraph>
          </div>
        </Beneficios>

        <Typography.Title level={3} style={{ marginBottom: 20 }}>
          Quer deixar sua cota disponível para oportunidades de venda?
        </Typography.Title>

        <Acoes>
          {onVoltar ? (
            <Button
              htmlType="button"
              disabled={submitting}
              onClick={onVoltar}
            >
              Voltar
            </Button>
          ) : null}
          <Button
            type="primary"
            htmlType="submit"
            loading={submitting}
            onClick={() => form.setFieldValue("desejaVender", true)}
          >
            Sim, quero anunciar minha cota
          </Button>
          <Button
            type="text"
            htmlType="button"
            disabled={submitting}
            onClick={() => {
              form.setFieldValue("desejaVender", false);
              form.submit();
            }}
          >
            Agora não
          </Button>
        </Acoes>
      </Form>
    </OnboardingFrame>
  );
}
